var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65991 3.375C3.65991 2.55 4.33491 1.875 5.15991 1.875H8.99991C10.9649 1.875 12.5624 3.4725 12.5624 5.4375C12.5624 7.4025 10.9649 9 8.99991 9H3.65991V3.375Z",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65991 9H10.7849C12.7499 9 14.3474 10.5975 14.3474 12.5625C14.3474 14.5275 12.7499 16.125 10.7849 16.125H5.15991C4.33491 16.125 3.65991 15.45 3.65991 14.625V9V9Z",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldTextIcon);
export default __webpack_public_path__ + "static/media/bold-text-icon.5124da66d2d95f17629d46488f030fb4.svg";
export { ForwardRef as ReactComponent };